<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header">
          <div>
            <h4>Thêm mới yêu cầu chấm công online</h4>
          </div>
        </div>
        <div class="main-body mt-1">
          <div class="main-body-table">
            <div class="form-card mb-3">
              <el-card class="box-card">
                <div>
                  <el-form
                    :model="mData.dataForm"
                    :rules="mData.validForm"
                    ref="myForm"
                    label-width="160px"
                    label-position="top"
                  >
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Phân loại"
                          prop="employee_request.type"
                        >
                          <el-select
                            disabled
                            clearable
                            filterable
                            v-model="mData.dataForm.employee_request.type"
                          >
                            <el-option
                              v-for="item in mData.dataDefault.listType"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          v-if="mData.reselectEmployee"
                          label="Nhân viên"
                          prop="employee_request.employee_id"
                        >
                          <el-select
                            filterable
                            v-model="
                              mData.dataForm.employee_request.employee_id
                            "
                            :disabled="!isSelectEmployee"
                            @change="fn_reSelectEmployee"
                            ref="employee_id"
                          >
                            <el-option
                              v-for="item in filteredRequestEmployees"
                              :key="item.id"
                              :label="fn_setLabelRespectively(item)"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1" v-if="mData.reselectEmployee">
                      <b-col md="6">
                        <el-form-item label="Chi nhánh">
                          <el-select v-model="requestEmployeeFilter.branch_ids" multiple filterable clearable disabled collapse-tags placeholder="Tất cả chi nhánh" @change="fn_resetEmployeeWhenFilteredOut">
                            <el-option v-for="item in filteredBranchList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                      <b-col md="6">
                        <el-form-item label="Phòng ban">
                          <el-select v-model="requestEmployeeFilter.department_ids" multiple filterable clearable disabled collapse-tags placeholder="Tất cả phòng ban" @change="fn_resetEmployeeWhenFilteredOut">
                            <el-option v-for="item in filteredDepartmentList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Quản lý trực tiếp"
                          prop="employee_request.level2Approval"
                        >
                          <DirectManagerField
                            v-model="
                              mData.dataForm.employee_request.level2Approval
                            "
                            :options="mData.dataDefault.listQuanLyTrucTiep"
                            :label-builder="fn_setLabelRespectively"
                          />
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Quản lý nhân sự"
                          prop="employee_request.employeeApproval"
                        >
                          <el-select
                            clearable
                            filterable
                            v-model="
                              mData.dataForm.employee_request.employeeApproval
                            "
                          >
                            <el-option
                              v-for="(item, index) in listHrApprove"
                              :key="item.e && item.e.id ? item.e.id : index"
                              :label="
                                item.e &&
                                item.e.administrative_info &&
                                item.e.administrative_info.name &&
                                item.e.administrative_info.name.full_name
                                  ?`${item.e.employee_no ? item.e.employee_no : ''} - ${item.e.administrative_info.name.full_name ? item.e.administrative_info.name.full_name : ''}`
                                  : 'không xác định'
                              "
                              :value="item.e && item.e.id ? item.e.id : ''"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item label="Ngày" prop="detail_request.date">
                          <el-date-picker
                            type="datetime"
                            v-model="mData.dataForm.detail_request.date"
                            :disabled="
                              mData.viewMode == 'detail' ||
                              mData.viewMode == 'create'
                            "
                            placeholder=""
                            prefix-icon="isax-calendar-1"
                            format="dd/MM/yyyy"
                          ></el-date-picker>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12" v-if="listEmployeeShiftDetail.length > 0">
                        <el-form-item
                          label="Ca làm việc"
                          prop="detail_request.shift_id"
                        >
                          <el-radio-group
                            v-model="mData.dataForm.detail_request.shift_id"
                            @change="fn_checkHadReqToday"
                          >
                            <el-radio
                              class="mr-3"
                              v-for="(shift, index) in listEmployeeShiftDetail"
                              :key="index"
                              :label="shift.id"
                              >{{ shift.name }}</el-radio
                            >
                          </el-radio-group>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Ghi chú"
                          prop="employee_request.content"
                        >
                          <el-input
                            type="textarea"
                            v-model="mData.dataForm.employee_request.content"
                            :disabled="mData.viewMode == 'detail'"
                            resize="none"
                            :autosize="{ minRows: 3, maxRows: 3 }"
                          ></el-input>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <div class="text-center mt-2">
                      <el-button
                        v-if="mData.viewMode == 'create'"
                        class="btn-default"
                        @click="fn_submitForm('create')"
                        :disabled="hadReq || !createRequest"
                        >Thêm mới</el-button
                      >
                      <el-button
                        v-if="mData.viewMode == 'create'"
                        class="btn-back"
                        @click="fn_goBack"
                        >Quay lại</el-button
                      >
                    </div>
                  </el-form>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MethodService from "../../../../service/MethodService";
import EmployeeRequestApi from "../../../../moduleApi/EmployeeRequestApi";
import EmployeeRequestTimeKeepingOnlineApi from "../../../../moduleApi/EmployeeRequestTimeKeepingOnlineApi";
import EmployeeShiftApi from "../../../../moduleApi/EmployeeShiftApi";
import DirectManagerField from "../components/DirectManagerField";
import { dataMixins } from "../../ManageRequests/RequestMixins/dataMixins";
import { fnMixins } from "../../ManageRequests/RequestMixins/fnMixins";
export default {
  components: { DirectManagerField },
  mixins: [dataMixins, fnMixins],
  data() {
    return {
      typeReq: "TIME_KEEPING_ONLINE",
      hadReq: false,
      showNoti: true,
      listReqCreated: [],
    };
  },
  computed: {
    filteredDepartmentList() {
      const employeeId = this.mData.dataForm.employee_request.employee_id;
      if (!employeeId) {
        return (this.mData.dataDefault.listDepartment || []).filter(
          (dept) => dept.company_id === this.currentCompany.id
        );
      }

      const selectedEmployee = this.fn_findRequestEmployeeById(employeeId);
      const departmentIds = [
        ...new Set(
          (this.fn_getActiveJobInfo(selectedEmployee) || [])
            .map((item) => item.department_id)
            .filter(Boolean)
        ),
      ];

      return (this.mData.dataDefault.listDepartment || []).filter((dept) =>
        departmentIds.includes(dept.id)
      );
    },
    filteredBranchList() {
      const employeeId = this.mData.dataForm.employee_request.employee_id;
      if (!employeeId) {
        return (this.mData.dataDefault.listBranch || []).filter(
          (branch) => branch.company_id === this.currentCompany.id
        );
      }

      const selectedEmployee = this.fn_findRequestEmployeeById(employeeId);
      const branchIds = [
        ...new Set(
          (this.fn_getActiveJobInfo(selectedEmployee) || [])
            .map((item) => item.branch_id)
            .filter(Boolean)
        ),
      ];

      return (this.mData.dataDefault.listBranch || []).filter((branch) =>
        branchIds.includes(branch.id)
      );
    },
  },

  methods: {
    async fn_innitDataDefault() {
      await this.fn_getListEmployee();
      await this.fn_getListEmployeeRequestReason(this.typeReq);
      await this.fn_getListEmployeeApprovedQLTT();
    },

    fn_syncRequestOrgFilterByEmployee(employeeId) {
      if (!employeeId) return;
      const selectedEmployee = this.fn_findRequestEmployeeById(employeeId);
      if (!selectedEmployee) return;

      const activeJobs = this.fn_getActiveJobInfo(selectedEmployee);
      this.requestEmployeeFilter.department_ids = [
        ...new Set(
          (activeJobs || [])
            .map((item) => item.department_id)
            .filter(Boolean)
        ),
      ];
      this.requestEmployeeFilter.branch_ids = [
        ...new Set(
          (activeJobs || [])
            .map((item) => item.branch_id)
            .filter(Boolean)
        ),
      ];

      this.$nextTick(() => {
        this.fn_resetEmployeeWhenFilteredOut();
      });
    },

    async fn_reSelectEmployee() {
      if (!this.mData.dataForm.employee_request.employee_id) {
        return;
      }

      this.fn_syncRequestOrgFilterByEmployee(
        this.mData.dataForm.employee_request.employee_id
      );
      await this.fn_initDataShift();
      this.mData.validForm.employee_request.employee_id = [];
      this.$nextTick(() => {
        if (this.$refs["myForm"]) {
          this.$refs["myForm"].clearValidate("employee_request.employee_id");
        }
      });
    },

    async fn_initDataShift() {
      this.createRequest = true;
      await this.fn_getListEmployeeApprovedQLTT(this.mData.dataForm.employee_request.employee_id, false);
      if (this.mData.dataForm.detail_request.shift_id) {
        this.$refs['myForm'].fields.find((f) => f.prop == "detail_request.shift_id").resetField()
      }
      let dataFilter = {
        filters:
          this.mData.tableRules.filters +
          (this.mData.tableRules.filters ? "&" : "") +
          "employee_id=" +
          this.mData.dataForm.employee_request.employee_id,
        fields: "shift_id,odd_names,start_time,end_time",
      };
      this.listEmployeeShift = []; //reset data
      let res = await EmployeeShiftApi.list(dataFilter);
      if (res.result) {
        const currentTime = new Date().getTime();
        res.result.forEach((el) => {
          if (el.start_time && el.end_time) {
            const startTime = new Date(el.start_time).getTime();
            const endTime = new Date(el.end_time).getTime();
            if (currentTime >= startTime && currentTime <= endTime) {
              this.listEmployeeShift.push(el);
            }
          } else if (el.start_time && !el.end_time) {
            const startTime = new Date(el.start_time).getTime();
            if (currentTime >= startTime) {
              this.listEmployeeShift.push(el);
            }
          }
        });
        this.listEmployeeShift = await this.fn_changeData(
          this.listEmployeeShift
        );
        this.listEmployeeShift.reverse();
        if (
          this.listEmployeeShift.length == 0 &&
          this.mData.dataForm.employee_request.employee_id
        ) {
          this.createRequest = false;
          window.toastr.warning(
            "Nhân viên hiện không có ca hiệu lực để tạo yêu cầu !"
          );
        } else {
          this.fn_getTotalReqToday();
        }
      }
    },

    async fn_getTotalReqToday() {
      this.hadReq = false;
      this.listReqCreated = [];

      if (this.mData.dataForm.employee_request.employee_id) {
        const employeeRequestApiRes = await EmployeeRequestApi.list({
          filters:
            "employee_id=" +
            this.mData.dataForm.employee_request.employee_id +
            "&type=TIME_KEEPING_ONLINE" +
            "&created_at>=" +
            new Date(new Date().setHours(0, 0, 0)).toISOString() +
            "&created_at<=" +
            new Date(new Date().setHours(23, 59, 59)).toISOString(),
          limit: 9999,
          sort: "-created_at",
        });
        if (employeeRequestApiRes.result.length > 0) {
          const res = employeeRequestApiRes.result;
          // today date to string 'yyyy-mm-dd'
          Date.prototype.today = function () {
            return (
              this.getFullYear() +
              "-" +
              (this.getMonth() + 1 < 10 ? "0" : "") +
              (this.getMonth() + 1) +
              "-" +
              (this.getDate() < 10 ? "0" : "") +
              this.getDate()
            );
          };
          const today = new Date(new Date().today()).getTime();
          res.forEach(async (item) => {
            const reqCreatedDate = new Date(
              item.created_at.slice(0, 10)
            ).getTime();
            if (today == reqCreatedDate) {
              const employeeReqTimeKeepingOnlineApiRes =
                await EmployeeRequestTimeKeepingOnlineApi.findById(item.id);
              const o = {
                shift_id: employeeReqTimeKeepingOnlineApiRes.result.shift_id,
                created_at: MethodService.formatDateYYYYMMDD(
                  new Date(reqCreatedDate),
                  "date"
                ),
              };
              this.listReqCreated.push(o);
            }
          });
        }
      }
    },

    fn_checkHadReqToday() {
      this.hadReq = false;
      const result = this.listReqCreated.find((item) => {
        if (item.shift_id == this.mData.dataForm.detail_request.shift_id) {
          this.hadReq = true;
          this.showNoti = true;
          return item;
        }
      });
      if (result) {
        if (
          this.currentUser.id ==
          this.mData.dataForm.employee_request.employee_id
        ) {
          window.toastr.options.timeOut = 5000;
          window.toastr.warning(
            "Ca này hôm nay bạn đã tạo yêu cầu chấm công online rồi !"
          );
          setTimeout(() => {
            window.toastr.options.timeOut = 3500;
          }, 2000);
        } else if (
          this.currentUser.id !=
            this.mData.dataForm.employee_request.employee_id &&
          this.hadReq
        ) {
          const employee = this.mData.dataDefault.listNhanVien.find(
            (el) => el.id == this.mData.dataForm.employee_request.employee_id
          );
          window.toastr.warning(
            `Ca này hôm nay ${employee.administrative_info.name.full_name} đã tạo yêu cầu chấm công online rồi !`
          );
        }
      } else if (!result) {
        this.fn_checkValidDate();
      }
    },

    fn_checkValidDate() {
      const currentTime = new Date().getTime();
      if (this.listEmployeeShift) {
        // check nếu thời gian hiện tại có trong thời gian hiệu lực của ca
          const idEmployeeShift = this.fn_checkValidShift(currentTime).shift_id;
        // check thời gian trong chấp nhận của ca trong ngày
        if (idEmployeeShift) {
          const t = this.mData.dataForm.detail_request.date;
          let todayShiftTime = [];
          const flag = this.fn_checkHasShiftAndNumberWordDay(t, todayShiftTime);
          if (flag) {
            this.createRequest = true;
            let validTimeCreateReq = false;
            this.listEmployeeShiftDetail.find((shift) => {
              if (shift.id == idEmployeeShift) {
                const acceptTimeStart = new Date(currentTime).setHours(
                  shift.acceptance_time_start.hour,
                  shift.acceptance_time_start.minute,
                  0
                );
                const acceptTimeEnd = new Date(currentTime).setHours(
                  shift.acceptance_time_end.hour,
                  shift.acceptance_time_end.minute,
                  0
                );
                if (
                  currentTime >= acceptTimeStart &&
                  currentTime <= acceptTimeEnd
                ) {
                  validTimeCreateReq = true;
                }
              }
            });
            if (!validTimeCreateReq) {
              window.toastr.warning(
                "Thời gian xin chấm công online phải trong khoảng từ khi bắt đầu đến khi kết thúc ca!"
              );
            }
          }
        } else {
          this.createRequest = false;
          window.toastr.warning("Ca này hiện không hiệu lực để tạo yêu cầu !");
        }
      } else {
        window.toastr.warning("Nhân viên không có ca để tạo yêu cầu !");
      }
    },

    //Form
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          try {
            let listApprovalUser = [];
            listApprovalUser = [
              {
                approval_user_id:
                  this.mData.dataForm.employee_request.level2Approval,
              },
              {
                approval_user_id:
                  this.mData.dataForm.employee_request.employeeApproval,
              },
            ];
            this.mData.dataForm.employee_request.content =
              this.mData.dataForm.employee_request.content.trim();
            this.mData.dataForm.employee_request.company_id =
              this.currentCompany.id;
            this.mData.dataForm.employee_request.is_sequential = true;
            this.mData.dataForm.employee_request.approval_level = 2;
            this.mData.dataForm.employee_request.approval_users =
              listApprovalUser;
            let dataEmployeeRequest = this.mData.dataForm.employee_request;
            let dataEmployeeRequestDetail = this.mData.dataForm.detail_request;
            if (type == "create") {
              if (!this.hadReq) {
                let createdRequestId = null;
                try {
                  const res = await EmployeeRequestApi.create(
                    dataEmployeeRequest
                  );
                  createdRequestId = res.result;
                  dataEmployeeRequestDetail.id = createdRequestId;

                  await EmployeeRequestTimeKeepingOnlineApi.create(
                    dataEmployeeRequestDetail
                  );
                } catch (error) {
                  if (createdRequestId) {
                    await EmployeeRequestApi.delete(createdRequestId);
                  }
                  throw error;
                }
                if (
                  this.mData.dataDefault.listFeature.includes("FT1001") ||
                  this.mData.dataDefault.listFeature.includes("FT1002")
                ) {
                  this.$router.push({
                    name: "Admin-ManageRequests-RequestsWaitingForApproval",
                  });
                }
                if (
                  this.currentUser.id ==
                  this.mData.dataForm.employee_request.employee_id
                ) {
                  this.showNoti = false;
                  await this.fn_getTotalReqToday();
                }
                this.fn_resetForm();
                this.listEmployeeShiftDetail = [];
                this.fn_checkHasEmployee();
              }
            }
          } catch (error) {
            console.log("error", error);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
  },

  async created() {
    this.mData.dataForm.employee_request.type = "TIME_KEEPING_ONLINE";
    this.mData.dataForm.detail_request.date = new Date();
    await this.fn_innitDataDefault();
    await this.fn_checkHasEmployee();
    this.fn_syncRequestOrgFilterByEmployee(
      this.mData.dataForm.employee_request.employee_id
    );
  },
  mounted() {},
};
</script>
<style scoped src="../../../../assets/css/layout/Request.css"></style>
